import { compose, overSome } from 'lodash/fp';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { TextKey } from '@mews-distributor/common';

import { fpViewWrapper } from '../../../enhancers/viewWrapper';
import { areAnyExchangeRatesFetching } from '../../../modules/entities/exchangeRates/selectors';
import { areReservationPricesFetching } from '../../../modules/entities/reservationPrices/selectors';
import { ApplicationState } from '../../../types';
import { hasFetchReservationPricesPendingRequest } from '../../../views/summary/data/selectors';

interface StateProps {
    isFetching: boolean;
}

export const withLoader = compose(
    connect<StateProps, {}, {}, ApplicationState>(
        createStructuredSelector({
            isFetching: overSome([
                areReservationPricesFetching,
                hasFetchReservationPricesPendingRequest,
                areAnyExchangeRatesFetching,
            ]),
        })
    ),
    fpViewWrapper({
        ContentContainer: <P extends {}>(props: P) => <div {...props} />,
        loader: {
            statusTextKey: TextKey.RecalculatingPrice,
        },
    })
);
